export default class ToggleButton extends PIXI.Sprite {
    constructor(onTexture, offTexture) {
        super(onTexture);

        this.callback = null;

        this.isOn = true;

        this.onTexture = onTexture;
        this.offTexture = offTexture;

        this.interactive = true;
        this.buttonMode = true;
        this.cursor = 'pointer';


        this.captured = false;

        this.on('pointerup', () => {
            if (this.captured) {
                this.captured = false;
            }

            this.isOn = !this.isOn;

            this.texture = this.isOn ? this.onTexture : this.offTexture;

            if (this.callback) {
                this.callback(this.isOn);
            }
        });

        // this.on('pointerover', () => {
        //     if (this.captured) {
        //         this.texture = overredTexture;
        //     }
        // });

        // this.on('pointerout', () => {
        //     this.texture = normalTexture;
        // });

        this.on('pointerdown',  event => {
            if (event.data.originalEvent.button != null && event.data.originalEvent.button === 0) {
                // this.texture = pressedTexture;
                this.captured = true;
            }
        });

        this.on('pointerupoutside', () => {
            // this.texture = normalTexture;
            this.captured = false;
        });
    }
}



// WEBPACK FOOTER //
// ./src/toggle_button.es6